import { Component, inject, Inject } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
// components & services
import { InputComponent } from '@app/core/components/input/input.component';
import { PwjToastService } from '@app/core/shared/services/app-toast.service';
// dialog ref
import { DialogRef } from '@app/core/shared/utils/dialog/dialog-ref';
import { DIALOG_DATA } from '@app/core/shared/utils/dialog/dialog-tokens';
// qr code library
import { QRCodeComponent } from 'angularx-qrcode';

@Component({
  selector: 'pwj-barcode-dialog',
  standalone: true,
  imports: [QRCodeComponent, InputComponent, TranslateModule],
  templateUrl: './barcode-dialog.component.html',
  styleUrl: './barcode-dialog.component.scss',
})
export class BarcodeDialogComponent {
  public title!: string;
  public barcodeContent!: string;
  public qrCodeLink: SafeUrl = '';
  public productTitle!: string;
  public productCode!: string;
  public outputPngName!: string;

  // dependencies
  private readonly _toaster = inject(PwjToastService);
  private readonly dialogRef = inject(DialogRef);
  public readonly data: {
    title: string;
    barcodeContent: string;
    productTitle: string;
    productCode: string;
  } = inject(DIALOG_DATA);

  constructor() {
    // dialog title
    this.title = this.data.title;

    // product data
    this.productTitle = this.data.productTitle;
    this.productCode = this.data.productCode;
    // set output png name
    this.outputPngName = `wejoiner-${this.productTitle}-(${this.productCode})`;

    // barcode content
    this.barcodeContent = this.data.barcodeContent;
  }

  // get qr code safe url for download that in png format
  public onChangeQrCode(url: SafeUrl) {
    this.qrCodeLink = url;
  }

  // copy link functionality
  public onCopyProductLink(link: string) {
    // copy text to clipboard
    navigator.clipboard
      .writeText(link)
      .then(_ => {
        this._toaster.success(
          'toastMessages.copyProductLink',
          'toastMessages.successTitle'
        );
      })
      .catch(_ => {
        this._toaster.error('toastMessages.error', 'toastMessages.errorTitle');
      });
  }

  public close() {
    this.dialogRef.close();
  }
}
